import { ColorDynamic } from '@superdispatch/ui';
import { createSvgIcon } from 'shared/icons/IconUtils';

export const ReplayIcon = createSvgIcon(
  'ReplayIcon',
  <path
    d="M11.7667 4.23335C10.8 3.26669 9.47334 2.66669 8.00001 2.66669C5.05334 2.66669 2.67334 5.05335 2.67334 8.00002C2.67334 10.9467 5.05334 13.3334 8.00001 13.3334C10.4867 13.3334 12.56 11.6334 13.1533 9.33335H11.7667C11.22 10.8867 9.74001 12 8.00001 12C5.79334 12 4.00001 10.2067 4.00001 8.00002C4.00001 5.79335 5.79334 4.00002 8.00001 4.00002C9.10667 4.00002 10.0933 4.46002 10.8133 5.18669L8.66667 7.33335H13.3333V2.66669L11.7667 4.23335Z"
    fill={ColorDynamic.Dark100}
  />,
  {
    viewBox: '0 0 16 16',
    style: { height: '16px', width: '16px', fill: 'none' },
  },
);
